import { selectNormalizedCategoriesWithTransactionsCount } from 'reducers/selectors';
export const getCategoryBadgeText = (activeFilter, store) => {
    if (!activeFilter.length)
        return '';
    const categories = selectNormalizedCategoriesWithTransactionsCount(store);
    const subcategories = activeFilter.filter((curr) => curr.parentCategoryId && curr.badgeText !== 'Others');
    const others = activeFilter.filter((curr) => curr.badgeText === 'Others');
    const directParents = activeFilter.filter((curr) => !curr.parentCategoryId);
    if (activeFilter.length === 1) {
        return activeFilter[0].badgeText;
    }
    const allParentIds = [
        ...subcategories.map((curr) => curr.parentCategoryId).filter(Boolean),
        ...others.map((curr) => curr.parentCategoryId).filter(Boolean),
        ...directParents.map((curr) => curr.id),
    ];
    const uniqueParentIds = new Set(allParentIds);
    if (uniqueParentIds.size > 1) {
        return `${activeFilter.length} categories`;
    }
    if (subcategories.length > 0) {
        const { parentCategoryId } = subcategories[0];
        if (!parentCategoryId)
            return `${activeFilter.length} categories`;
        const parentCategory = categories[parentCategoryId];
        if (!parentCategory)
            return `${activeFilter.length} categories`;
        if (activeFilter.some((curr) => curr.id === parentCategoryId && curr.badgeText !== 'Others')) {
            return parentCategory.displayName;
        }
        const activeSubcategories = (parentCategory.subCategoryIds || []).filter((id) => {
            const category = categories[id];
            return category && (category.transactionsCount ?? 0) > 0;
        });
        const selectedSubcategoryIds = subcategories.map((curr) => curr.id);
        const hasAllSubcategories = activeSubcategories.every((id) => selectedSubcategoryIds.includes(id));
        if (hasAllSubcategories && others.length > 0) {
            return parentCategory.displayName;
        }
        if (subcategories.length === 1 && others.length === 1) {
            return `${subcategories[0].badgeText} & others`;
        }
        if (subcategories.length > 1 && others.length === 1) {
            return `${subcategories.length} categories & others`;
        }
        return subcategories.length === 1 ? subcategories[0].badgeText : `${subcategories.length} categories`;
    }
    return `${activeFilter.length} categories`;
};
